/* JW_NL_JS_V1_BEGIN */
if (document.documentElement.lang === 'nl') {
/* Kumo-only, progressive enhancement. Never creates a cart request or changes variant/quantity. */
(() => {
  if (window.jwKumoMobileLoaded) return;
  window.jwKumoMobileLoaded = true;
  const init = () => document.querySelectorAll('[data-jw-kumo][data-product-id="10644009451859"]').forEach((root) => {
    if (root.dataset.jwKumoReady) return;
    const bar = root.querySelector('[data-jw-kumo-buybar]');
    const data = root.querySelector('[data-jw-kumo-variants]');
    if (!bar || !data) return;
    let variants;
    try {
      // Serialize the array directly in Liquid: a Liquid for-loop is limited to 50 iterations.
      const raw = JSON.parse(data.textContent);
      const expectedCount = Number(data.dataset.variantCount);
      if (!Array.isArray(raw) || !Number.isSafeInteger(expectedCount) || expectedCount < 1 || raw.length !== expectedCount || !data.dataset.locale || !data.dataset.currency) return;
      const formatter = new Intl.NumberFormat(data.dataset.locale, {style:'currency', currency:data.dataset.currency});
      variants = new Map();
      for (const v of raw) {
        if (!Number.isSafeInteger(v.id) || v.id <= 0 || !Number.isSafeInteger(v.price) || v.price < 0 ||
            !Array.isArray(v.options) || v.options.length !== 2 || !v.options.every(option => typeof option === 'string') ||
            typeof v.available !== 'boolean' || variants.has(String(v.id))) return;
        variants.set(String(v.id), {id:v.id, color:v.options[0], size:v.options[1], money:formatter.format(v.price / 100), available:v.available});
      }
    } catch (_) { return; }
    root.dataset.jwKumoReady = 'true';
    const section = root.dataset.jwKumo;
    const action = bar.querySelector('[data-jw-kumo-bar-add]');
    let scheduled = false;
    let locked = false;
    let lockTimer;
    const visible = (el) => {
      if (!el || el.hidden || el.closest('[hidden],[inert],[aria-hidden="true"]')) return false;
      const r = el.getBoundingClientRect();
      const s = getComputedStyle(el);
      return s.visibility !== 'hidden' && s.display !== 'none' && s.opacity !== '0' && r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth;
    };
    const overlays = () => [...document.querySelectorAll('[role="dialog"],[role="alertdialog"],[aria-modal="true"],.jw-popup__overlay,cart-drawer.active,menu-drawer details[open],#essential-cart-drawer-portal [data-essential-cart-element="cart-drawer-overlay"]')].some(visible);
    const appSticky = () => [...document.querySelectorAll('[data-essential-cart-element*="sticky"],[id*="bundlex"],[class*="bundlex"],[class*="bx-sticky"],#essential-cart-drawer-portal button,#essential-cart-drawer-portal a')].some(el => {
      if (!visible(el)) return false;
      for (let node = el; node && node !== document.body; node = node.parentElement) {
        const r = node.getBoundingClientRect();
        if (getComputedStyle(node).position === 'fixed' && r.bottom > innerHeight - 120 && r.top > innerHeight / 2) return true;
      }
      return false;
    });
    const state = () => {
      // Resolve on every pass: Craft replaces the picker and price after a variant fetch.
      const picker = root.querySelector('variant-selects');
      const button = document.getElementById(`ProductSubmitButton-${section}`);
      const form = button?.closest('form[data-type="add-to-cart-form"]');
      const id = form?.querySelector('.product-variant-id[name="id"]')?.value;
      const variant = variants.get(String(id));
      const options = picker ? [...picker.querySelectorAll('select')].map(s => s.value) : [];
      let selected;
      try { selected = JSON.parse(picker?.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch (_) {}
      const consistent = !!variant && String(selected?.id) === String(id) && options.length === 2 && options[0] === variant.color && options[1] === variant.size;
      const quantity = root.querySelector(`#Quantity-${CSS.escape(section)}`);
      const error = root.querySelector('.product-form__error-message-wrapper:not([hidden])');
      const busy = locked || button?.classList.contains('loading') || button?.getAttribute('aria-disabled') === 'true' || form?.getAttribute('aria-busy') === 'true';
      const bundle = !!document.querySelector('input[name="bx-product-form"],input[name^="properties[_bundlex"],[id*="bundlex"],[class*="bundlex"]');
      return {picker, button, form, variant, consistent, quantity, error, busy, bundle};
    };
    const write = (selector, text) => {
      const el = bar.querySelector(selector);
      if (el.textContent !== text) el.textContent = text;
    };
    const refresh = () => {
      scheduled = false;
      if (!root.isConnected) { observer.disconnect(); return; }
      const s = state();
      const quantity = s.quantity?.value || '1';
      // If a bundle owns price/selection, leave its native price intact and avoid a misleading unit-price caption.
      const caption = root.querySelector('.jw-kumo-selected-size');
      if (caption && caption.hidden !== s.bundle) caption.hidden = s.bundle;
      write('[data-jw-kumo-bar-options]', s.consistent ? `${s.variant.color} · ${s.variant.size}` : 'Choisissez couleur et taille');
      write('[data-jw-kumo-bar-price]', s.bundle ? 'Offre à vérifier' : s.consistent ? `${s.variant.money} / pièce` : '');
      write('[data-jw-kumo-bar-quantity]', s.bundle ? '' : `Aantal: ${quantity}`);
      write('[data-jw-kumo-bar-add]', s.bundle ? 'Bekijk het aanbod' : s.busy ? 'Even geduld…' : s.consistent && s.variant.available ? 'Toevoegen' : 'Kiezen');
      const disabled = s.busy || !!s.error || (!!s.button?.disabled && s.consistent);
      if (action.disabled !== !!disabled) action.disabled = !!disabled;
      const passedChoices = s.picker && s.picker.getBoundingClientRect().bottom < 0;
      const nativeVisible = !!s.button && (visible(s.button) || [...root.querySelectorAll('.shopify-payment-button')].some(visible));
      const editing = document.activeElement?.matches('select,input,textarea,[contenteditable="true"]');
      // The unpublished theme preview has its own bottom toolbar. Never cover it.
      const preview = document.getElementById('PBarNextFrameWrapper');
      const previewHeight = visible(preview) ? Math.ceil(preview.getBoundingClientRect().height) : 0;
      if (root.style.getPropertyValue('--jw-kumo-preview-height') !== `${previewHeight}px`) root.style.setProperty('--jw-kumo-preview-height', `${previewHeight}px`);
      const hide = !matchMedia('(max-width: 749px)').matches || !passedChoices || nativeVisible || editing || overlays() || appSticky() || !s.button || !!s.error;
      if (bar.hidden !== !!hide) bar.hidden = !!hide;
    };
    const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(refresh); } };
    const unlock = () => { locked = false; clearTimeout(lockTimer); schedule(); };
    action.addEventListener('click', () => {
      const s = state();
      if (s.busy || overlays() || appSticky() || s.error) return;
      if (s.bundle || !s.consistent || !s.variant.available || s.button?.disabled) {
        const target = s.bundle ? root.querySelector('.product__info-container') : s.picker;
        target?.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center'});
        if (!s.bundle) s.picker?.querySelector('select')?.focus({preventScroll:true});
        return;
      }
      locked = true;
      action.disabled = true;
      // Keep Craft, Essential and potential BundleX listeners on the original button/form.
      s.button.click();
      schedule();
      lockTimer = setTimeout(unlock, 10000);
    });
    /* jw-kumo-review-focus:start — clearance on focus, not a permanent blank section. */
    root.addEventListener('focusin', (event) => {
      const target = event.target;
      if (!matchMedia('(max-width: 749px)').matches ||
          !target.matches('#jw-reviews .jw-reviews-grid, #jw-reviews .jw-reviews-more')) return;
      requestAnimationFrame(() => {
        if (!root.isConnected || document.activeElement !== target || overlays()) return;
        const rect = target.getBoundingClientRect();
        let bottom = innerHeight;
        if (!bar.hidden && visible(bar)) bottom = Math.min(bottom, bar.getBoundingClientRect().top - 16);
        const preview = document.getElementById('PBarNextFrameWrapper');
        if (visible(preview)) bottom = Math.min(bottom, preview.getBoundingClientRect().top - 16);
        if (rect.bottom > bottom || rect.top < 0) {
          target.scrollIntoView({block: 'center', inline: 'nearest', behavior: 'auto'});
        }
      });
    });
    /* jw-kumo-review-focus:end */
    root.addEventListener('change', schedule);
    root.addEventListener('input', schedule);
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    document.addEventListener('product-info:loaded', schedule);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      for (const event of [PUB_SUB_EVENTS.variantChange, PUB_SUB_EVENTS.quantityUpdate]) if (event) subscribe(event, schedule);
      for (const event of [PUB_SUB_EVENTS.cartUpdate, PUB_SUB_EVENTS.cartError]) if (event) subscribe(event, unlock);
    }
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class','style','hidden','aria-hidden','aria-disabled','disabled','value','open']});
    refresh();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();

} else { /* JW_NL_JS_FR_ORIGINAL_V1 */
/* Kumo-only, progressive enhancement. Never creates a cart request or changes variant/quantity. */
(() => {
  if (window.jwKumoMobileLoaded) return;
  window.jwKumoMobileLoaded = true;
  const init = () => document.querySelectorAll('[data-jw-kumo][data-product-id="10644009451859"]').forEach((root) => {
    if (root.dataset.jwKumoReady) return;
    const bar = root.querySelector('[data-jw-kumo-buybar]');
    const data = root.querySelector('[data-jw-kumo-variants]');
    if (!bar || !data) return;
    let variants;
    try {
      // Serialize the array directly in Liquid: a Liquid for-loop is limited to 50 iterations.
      const raw = JSON.parse(data.textContent);
      const expectedCount = Number(data.dataset.variantCount);
      if (!Array.isArray(raw) || !Number.isSafeInteger(expectedCount) || expectedCount < 1 || raw.length !== expectedCount || !data.dataset.locale || !data.dataset.currency) return;
      const formatter = new Intl.NumberFormat(data.dataset.locale, {style:'currency', currency:data.dataset.currency});
      variants = new Map();
      for (const v of raw) {
        if (!Number.isSafeInteger(v.id) || v.id <= 0 || !Number.isSafeInteger(v.price) || v.price < 0 ||
            !Array.isArray(v.options) || v.options.length !== 2 || !v.options.every(option => typeof option === 'string') ||
            typeof v.available !== 'boolean' || variants.has(String(v.id))) return;
        variants.set(String(v.id), {id:v.id, color:v.options[0], size:v.options[1], money:formatter.format(v.price / 100), available:v.available});
      }
    } catch (_) { return; }
    root.dataset.jwKumoReady = 'true';
    const section = root.dataset.jwKumo;
    const action = bar.querySelector('[data-jw-kumo-bar-add]');
    let scheduled = false;
    let locked = false;
    let lockTimer;
    const visible = (el) => {
      if (!el || el.hidden || el.closest('[hidden],[inert],[aria-hidden="true"]')) return false;
      const r = el.getBoundingClientRect();
      const s = getComputedStyle(el);
      return s.visibility !== 'hidden' && s.display !== 'none' && s.opacity !== '0' && r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth;
    };
    const overlays = () => [...document.querySelectorAll('[role="dialog"],[role="alertdialog"],[aria-modal="true"],.jw-popup__overlay,cart-drawer.active,menu-drawer details[open],#essential-cart-drawer-portal [data-essential-cart-element="cart-drawer-overlay"]')].some(visible);
    const appSticky = () => [...document.querySelectorAll('[data-essential-cart-element*="sticky"],[id*="bundlex"],[class*="bundlex"],[class*="bx-sticky"],#essential-cart-drawer-portal button,#essential-cart-drawer-portal a')].some(el => {
      if (!visible(el)) return false;
      for (let node = el; node && node !== document.body; node = node.parentElement) {
        const r = node.getBoundingClientRect();
        if (getComputedStyle(node).position === 'fixed' && r.bottom > innerHeight - 120 && r.top > innerHeight / 2) return true;
      }
      return false;
    });
    const state = () => {
      // Resolve on every pass: Craft replaces the picker and price after a variant fetch.
      const picker = root.querySelector('variant-selects');
      const button = document.getElementById(`ProductSubmitButton-${section}`);
      const form = button?.closest('form[data-type="add-to-cart-form"]');
      const id = form?.querySelector('.product-variant-id[name="id"]')?.value;
      const variant = variants.get(String(id));
      const options = picker ? [...picker.querySelectorAll('select')].map(s => s.value) : [];
      let selected;
      try { selected = JSON.parse(picker?.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch (_) {}
      const consistent = !!variant && String(selected?.id) === String(id) && options.length === 2 && options[0] === variant.color && options[1] === variant.size;
      const quantity = root.querySelector(`#Quantity-${CSS.escape(section)}`);
      const error = root.querySelector('.product-form__error-message-wrapper:not([hidden])');
      const busy = locked || button?.classList.contains('loading') || button?.getAttribute('aria-disabled') === 'true' || form?.getAttribute('aria-busy') === 'true';
      const bundle = !!document.querySelector('input[name="bx-product-form"],input[name^="properties[_bundlex"],[id*="bundlex"],[class*="bundlex"]');
      return {picker, button, form, variant, consistent, quantity, error, busy, bundle};
    };
    const write = (selector, text) => {
      const el = bar.querySelector(selector);
      if (el.textContent !== text) el.textContent = text;
    };
    const refresh = () => {
      scheduled = false;
      if (!root.isConnected) { observer.disconnect(); return; }
      const s = state();
      const quantity = s.quantity?.value || '1';
      // If a bundle owns price/selection, leave its native price intact and avoid a misleading unit-price caption.
      const caption = root.querySelector('.jw-kumo-selected-size');
      if (caption && caption.hidden !== s.bundle) caption.hidden = s.bundle;
      write('[data-jw-kumo-bar-options]', s.consistent ? `${s.variant.color} · ${s.variant.size}` : 'Choisissez couleur et taille');
      write('[data-jw-kumo-bar-price]', s.bundle ? 'Offre à vérifier' : s.consistent ? `${s.variant.money} / pièce` : '');
      write('[data-jw-kumo-bar-quantity]', s.bundle ? '' : `Quantité : ${quantity}`);
      write('[data-jw-kumo-bar-add]', s.bundle ? 'Voir l’offre' : s.busy ? 'En cours…' : s.consistent && s.variant.available ? 'Ajouter' : 'Choisir');
      const disabled = s.busy || !!s.error || (!!s.button?.disabled && s.consistent);
      if (action.disabled !== !!disabled) action.disabled = !!disabled;
      const passedChoices = s.picker && s.picker.getBoundingClientRect().bottom < 0;
      const nativeVisible = !!s.button && (visible(s.button) || [...root.querySelectorAll('.shopify-payment-button')].some(visible));
      const editing = document.activeElement?.matches('select,input,textarea,[contenteditable="true"]');
      // The unpublished theme preview has its own bottom toolbar. Never cover it.
      const preview = document.getElementById('PBarNextFrameWrapper');
      const previewHeight = visible(preview) ? Math.ceil(preview.getBoundingClientRect().height) : 0;
      if (root.style.getPropertyValue('--jw-kumo-preview-height') !== `${previewHeight}px`) root.style.setProperty('--jw-kumo-preview-height', `${previewHeight}px`);
      const hide = !matchMedia('(max-width: 749px)').matches || !passedChoices || nativeVisible || editing || overlays() || appSticky() || !s.button || !!s.error;
      if (bar.hidden !== !!hide) bar.hidden = !!hide;
    };
    const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(refresh); } };
    const unlock = () => { locked = false; clearTimeout(lockTimer); schedule(); };
    action.addEventListener('click', () => {
      const s = state();
      if (s.busy || overlays() || appSticky() || s.error) return;
      if (s.bundle || !s.consistent || !s.variant.available || s.button?.disabled) {
        const target = s.bundle ? root.querySelector('.product__info-container') : s.picker;
        target?.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center'});
        if (!s.bundle) s.picker?.querySelector('select')?.focus({preventScroll:true});
        return;
      }
      locked = true;
      action.disabled = true;
      // Keep Craft, Essential and potential BundleX listeners on the original button/form.
      s.button.click();
      schedule();
      lockTimer = setTimeout(unlock, 10000);
    });
    /* jw-kumo-review-focus:start — clearance on focus, not a permanent blank section. */
    root.addEventListener('focusin', (event) => {
      const target = event.target;
      if (!matchMedia('(max-width: 749px)').matches ||
          !target.matches('#jw-reviews .jw-reviews-grid, #jw-reviews .jw-reviews-more')) return;
      requestAnimationFrame(() => {
        if (!root.isConnected || document.activeElement !== target || overlays()) return;
        const rect = target.getBoundingClientRect();
        let bottom = innerHeight;
        if (!bar.hidden && visible(bar)) bottom = Math.min(bottom, bar.getBoundingClientRect().top - 16);
        const preview = document.getElementById('PBarNextFrameWrapper');
        if (visible(preview)) bottom = Math.min(bottom, preview.getBoundingClientRect().top - 16);
        if (rect.bottom > bottom || rect.top < 0) {
          target.scrollIntoView({block: 'center', inline: 'nearest', behavior: 'auto'});
        }
      });
    });
    /* jw-kumo-review-focus:end */
    root.addEventListener('change', schedule);
    root.addEventListener('input', schedule);
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    document.addEventListener('product-info:loaded', schedule);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      for (const event of [PUB_SUB_EVENTS.variantChange, PUB_SUB_EVENTS.quantityUpdate]) if (event) subscribe(event, schedule);
      for (const event of [PUB_SUB_EVENTS.cartUpdate, PUB_SUB_EVENTS.cartError]) if (event) subscribe(event, unlock);
    }
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class','style','hidden','aria-hidden','aria-disabled','disabled','value','open']});
    refresh();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();

}
/* JW_NL_JS_V1_END */